var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.title,"width":_vm.width,"visible":_vm.model,"append-to-body":true,"close-on-click-modal":false,"show-close":_vm.showclose,"before-close":_vm.beforeClose},on:{"opened":_vm.opened,"update:visible":function($event){_vm.model=$event},"close":_vm.close}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }